import { Menu, MenuItem } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'

import MoreVertIcon from '@material-ui/icons/MoreVert'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import HelpButton from 'src/components/sections/Navbar/HelpButton'
import LanguageButton from 'src/components/sections/Navbar/LanguageButton'
import SettingsButton from 'src/components/sections/Navbar/SettingsButton'

const useStyles = makeStyles((theme) => ({
	moveIcon: {
		color: theme.palette.primary.main,
		padding: '0',
		fontSize: '0.75rem',
	},
	deleteIcon: {
		color: theme.palette.primary.main,
		padding: '0',
		fontSize: '0.75rem',
	},
	editIcon: {
		color: theme.palette.primary.main,
		padding: '0',
		fontSize: '0.75rem',
	},
	reportIcon: {
		color: theme.palette.primary.main,
		padding: '0',
		fontSize: '0.75rem',
	},
	actionButtons: {
		display: 'flex',
	},
}))

function GridNavbarMobileActions({
	handleLogout,
	isSmall,
}: {
	handleLogout: any
	isSmall: boolean
}) {
	const classes = useStyles()
	const { t } = useTranslation()
	const [isMenuOpen, setIsMenuOpen] = useState(null)
	const ITEM_HEIGHT = 48
	const handleClick = (event: any) => {
		setIsMenuOpen(event.currentTarget)
	}

	const handleClose = () => {
		setIsMenuOpen(null)
	}
	return (
		<div style={{ display: 'flex', justifyContent: 'end' }}>
			<IconButton
				aria-controls="simple-menu"
				aria-haspopup="true"
				onClick={handleClick}
				style={{ textTransform: 'capitalize', color: 'white' }}
			>
				<MoreVertIcon />
			</IconButton>
			<Menu
				id="simple-menu"
				anchorEl={isMenuOpen}
				keepMounted
				open={Boolean(isMenuOpen)}
				onClose={handleClose}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'center',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 4.5,
						// width: '10ch',
					},
				}}
			>
				{/* <MenuItem>
					<OfflineButton />
				</MenuItem> */}
				<MenuItem>
					<LanguageButton />
				</MenuItem>
				<MenuItem>
					<HelpButton />
				</MenuItem>
				<MenuItem>
					<SettingsButton
						handleLogout={handleLogout}
						isSmall={isSmall}
					/>
				</MenuItem>
			</Menu>
		</div>
	)
}

export default GridNavbarMobileActions
